<template>
  <section id="campuses" class="py-16 px-4 md:px-8 lg:px-16 bg-gray-800 text-white">
    <div class="max-w-6xl mx-auto text-center mb-12">
      <h2 class="text-4xl font-bold mb-4">{{ themeStore.theme.Campuses.title }}</h2>
      <p class="text-gray-300 max-w-2xl mx-auto leading-relaxed">
      {{ themeStore.theme.Campuses.subtitle }} 
         </p>
    </div>

    <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div
        v-for="(campus, index) in themeStore.theme.Campuses.Card"
        :key="index"
        class="bg-gray-900 rounded-lg shadow-lg cursor-pointer overflow-hidden transform transition-transform duration-300 hover:scale-[1.02] hover:shadow-xl"
      >
        <img :src="campus.image" :alt="campus.name" class="w-full h-48 object-cover" />
        <div class="p-6">
          <h3 class="text-2xl font-semibold mb-2 text-purple-400">{{ campus.name }}</h3>
          <p class="text-gray-400 leading-relaxed">{{ campus.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useThemeStore } from '../../stores/themeStore';
import index from '@/dashbaord/index.vue'
import Campuses from '@/website/components/Campuses.vue'

const themeStore = useThemeStore();
</script>
